import React from 'react';

import Banner from '../img/ContactHero.jpg';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default () => (
  <div className="antialiased text-gray-900 min-h-screen flex flex-col">
    <Navbar />
    <div style={{ height: '19rem' }}>
      <img
        src={Banner}
        className="h-full w-full object-cover"
        style={{ objectPosition: '50% 45%' }}
      />
    </div>
    <main className="flex-grow">
      <div>
        <h1 className="text-center font-bold text-4xl mt-4">Contact Us</h1>
        <div className="mt-8">
          <div className="px-24 mt-2 text-center text-lg pb-12">
            316 Wapping St., Rm. 204
            <br />
            Frankfort, KY 40601
            <br />
            502-699-2553 office
            <br />
            <a href="mailto:andy@apogeeclimate.org">andy@ApogeeClimate.org</a>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);
